export const API_URL = process.env.REACT_APP_API_URL;
export const BASE_AVATAR_URL = process.env.REACT_APP_BASE_AVATAR_URL;
export const USER_API_URL = process.env.REACT_APP_USER_API_URL;
